// extracted by mini-css-extract-plugin
export default {"cursor":"Cursor_cursor_xB5dI","hover":"Cursor_hover_jrqc0"};